/**
 * @generated SignedSource<<a037e1c431ad27567316ea00b89b8817>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */
'use strict';

var node = function () {
  var v0 = [{
    "alias": null,
    "args": null,
    "concreteType": "signedUrlData",
    "kind": "LinkedField",
    "name": "legalTermsUploadUrl",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdfUniqueName",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedUrl",
      "storageKey": null
    }],
    "storageKey": null
  }];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "uploadPDFQuery",
      "selections": v0
      /*: any*/
      ,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "uploadPDFQuery",
      "selections": v0
      /*: any*/

    },
    "params": {
      "cacheID": "bb9c3ee5eab6931a0bec66e8992d9c5e",
      "id": null,
      "metadata": {},
      "name": "uploadPDFQuery",
      "operationKind": "query",
      "text": "query uploadPDFQuery {\n  legalTermsUploadUrl {\n    pdfUniqueName\n    signedUrl\n  }\n}\n"
    }
  };
}();

node.hash = "3bbb914949390eb2b513318f031fc9bd";
module.exports = node;